import { required, maxLength, numeric, minValue } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
    audioPrincipal: { required },
    quantidadeDigitos: { required, numeric, minValue: minValue(1) },
    quantidadeDeLoops: { required, numeric },
    timeout: { numeric },
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Nome é obrigatório.')
    !this.$v.form.description.maxLength && errors.push('Nome não pode conter mais de 30 caracteres.')
    return errors
  },
  audioPrincipalErrors() {
    const errors = []
    if (!this.$v.form.audioPrincipal.$dirty) return errors
    !this.$v.form.audioPrincipal.required && errors.push('Escolha ao menos um áudio principal.')
    return errors
  },
  quantidadeDigitosErrors() {
    const errors = []
    if (!this.$v.form.quantidadeDigitos.$dirty) return errors
    !this.$v.form.quantidadeDigitos.required && errors.push('Quantidade de dígitos é obrigatório.')
    !this.$v.form.quantidadeDigitos.numeric && errors.push('Apenas caracteres numéricos são aceitos.')
    !this.$v.form.quantidadeDigitos.minValue && errors.push('Menor valor aceito é 1.')
    return errors
  },
  quantidadeDeLoopsErrors() {
    const errors = []
    if (!this.$v.form.quantidadeDeLoops.$dirty) return errors
    !this.$v.form.quantidadeDeLoops.required && errors.push('Quantidade de loops é obrigatório.')
    !this.$v.form.quantidadeDeLoops.numeric && errors.push('Apenas caracteres numéricos são aceitos.')
    return errors
  },
  timeoutErrors() {
    const errors = []
    if (!this.$v.form.timeout.$dirty) return errors
    !this.$v.form.timeout.numeric && errors.push('Apenas caracteres numéricos são aceitos.')
    return errors
  },
}
